

import React, {Component} from 'react';
import HotelForOrderItem from './hotel_order_item.component';

class HotelsForOrderList extends Component {

  componentDidMount = () => {

    console.log('HotelsForOrderList componentDidMount props' ,this.props);
  }

  DisplayForOrder = (data) => {
    this.props.DisplayForOrder(data);
  }

  DisplayForHotelDetails = (hotelId) => {
    console.log('HotelsList DisplayForDetails hotelId', hotelId);
    this.props.DisplayForHotelDetails(hotelId);
  }

  render() { 

    let hotelsForOrderList = <div></div>;
    if ( this.props.hotelsForOrder != undefined) {
       hotelsForOrderList = this.props.hotelsForOrder.map((h) =>
          <HotelForOrderItem  
            key={h.key} 
            hotelForOrder={h} 
            DisplayForOrder={this.DisplayForOrder}
            DisplayForHotelDetails={this.DisplayForHotelDetails}
            />        
    ); }

    return (
        <div className="cntered-flex ">
            <div className="main_grid_container">
                {hotelsForOrderList}
            </div>
        </div>
    )
  }
}

export default HotelsForOrderList;
